import { useState, useCallback } from "react";
import { WidgetData } from "@/types/document";

export const useWidgetData = () => {
  const [widgetDataMap, setWidgetDataMap] = useState<Map<string, WidgetData>>(new Map());

  const updateWidgetData = useCallback((widgetId: string, glossaryItemId: string, data: Record<string, unknown>) => {
    setWidgetDataMap(prevMap => {
      const newMap = new Map(prevMap);
      newMap.set(widgetId, { widgetId, glossaryItemId, data });
      return newMap;
    });
  }, []);

  const getWidgetDataObject = useCallback((): Record<string, WidgetData> => {
    const widgetDataObject: Record<string, WidgetData> = {};
    widgetDataMap.forEach((widgetData, widgetId) => {
      widgetDataObject[widgetId] = widgetData;
    });
    return widgetDataObject;
  }, [widgetDataMap]);

  return {
    updateWidgetData,
    getWidgetDataObject,
  };
};
